const SET_SELECTED_MENU = '@home/set-selected-menu';

export {SET_SELECTED_MENU};